<script setup>
  import { storeToRefs } from "pinia";
  import { computed, ref } from "vue";
  import { useRouter } from "vue-router";

  import OnePanePage from "@/templates/OnePanePage.vue";
  import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
  import { Button } from "@/components/ui/button";
  import { LoadingOverlay } from "@/components/episto-ui/loading-overlay";
  import GeneralSetupSection from "@/components/Job/Setup/GeneralSetupSection.vue";
  import { useJobsStore } from "@stores/job/jobs";

  const router = useRouter();
  const { isNew, currentJob } = storeToRefs(useJobsStore());
  const { createJob, updateJob } = useJobsStore();

  const isSaving = ref(false);
  const pageTitle = computed(() => (isNew.value ? "New job" : `Edit ${currentJob.value?.name}`));
  const loadingText = computed(() =>
    isNew.value ? "Your job is being created..." : "Your job is being updated...",
  );

  const handleSave = async () => {
    isSaving.value = true;
    try {
      if (isNew.value) await createJob();
      else await updateJob();

      router.push({ name: "JobsIndex" });
    } finally {
      isSaving.value = false;
    }
  };
</script>

<template>
  <OnePanePage :span-center="6">
    <Card
      class="p-6"
      data-cy="jobs-new-job-page jobs-edit-job-page">
      <CardHeader class="pb-6">
        <CardTitle class="heading-page">{{ pageTitle }}</CardTitle>
      </CardHeader>
      <CardContent>
        <GeneralSetupSection />
        <Button
          class="mt-6 w-full"
          @click="handleSave">
          Save
        </Button>
      </CardContent>
    </Card>
    <LoadingOverlay
      v-if="isSaving"
      :text="loadingText" />
  </OnePanePage>
</template>
